import { repositoryCache } from './repositoryCache';
let repos;
export function initRepositoryRegistry(repositories) {
    repos = repositories;
    repositoryCache.clear();
}
export function getRepositories() {
    if (!repos) {
        throw new Error('Repository registry not initialized. Call initRepositoryRegistry() first.');
    }
    return repos;
}
